import React from "react";
import { useNavigate } from 'react-router-dom';
//components
import Button from '../../../../components/generics/Button';
//assets
import './style.scss';

const SuccessModal = ({ icon, text, buttonText, setSuccessModal }: any) => {
    const navigate = useNavigate();
    const handleClickSuccessModal = () => {
        setSuccessModal(false);
        navigate('/cotacoes-dashboard');
    };
    return (
        <>
            <div className="container-success">
                <div className="modalImg">
                    <img src={icon} />
                </div>
                <div className="modalText">
                    <h1>{text}</h1>
                </div>
                <div className="modalButton">
                    <Button
                        label={buttonText} onClick={handleClickSuccessModal}
                    ></Button>
                </div>
            </div>
        </>
    );
};

export default SuccessModal;
